<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card reporting-category-modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">
          Reporting Category History
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="enable-select-text">
          <circul8-table
            ref="circul8Table"
            className="reporting-category-history-table"
            :records="data"
            :fields="columns"
            :routeNext="false"
            :usePropRecords="true"
            :showRemoveButton="false"
            :showEditButton="false"
            :showViewButton="false"
            :isCheckable="false"
            :maxTextLength="'36'"
            :allCountries="countries"
          />
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button
          slot="right"
          type="is-info"
          @click="exportHistoryReportingCategory"
          :disabled="data.length === 0"
        >
          Export
        </b-button>
        <b-button slot="right" type="is-normal" @click="cancel">
          Close
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import utilityMixin from "@/mixins/UtilityMixin";
import ScopeMixin from "@/mixins/scopeMixin";
import ReportingCategoryService from "@/services/ReportingCategoryService";
import Circul8Table from "../../components/Circul8Table.vue";
export default {
  name: "ReportingCategoryHistoryModal",
  mixins: [utilityMixin, ScopeMixin],
  components: { Circul8Table },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    data: {}
  },
  data() {
    return {
      isModalActive: false,
      reportingCategoryService: new ReportingCategoryService(),
      columns: [
        {
          field: "customer",
          label: "Customer",
          searchable: true
        },
        {
          field: "entity",
          label: "Entity",
          searchable: true
        },
        {
          field: "country",
          label: "Country",
          searchable: true
        },
        {
          field: "stream",
          label: "Stream",
          searchable: true
        },
        {
          field: "scheme",
          label: "Scheme",
          searchable: true
        },
        {
          field: "short_report_name",
          label: "Short Report Name",
          searchable: true
        },
        {
          field: "main_category",
          label: "Main Category",
          searchable: true
        },
        {
          field: "sub_category",
          label: "Sub Category",
          searchable: true
        },
        {
          field: "valid_from",
          label: "Valid From",
          searchable: true
        },
        {
          field: "valid_to",
          label: "Valid To",
          searchable: true
        },
        {
          field: "example_product",
          label: "Example of Product",
          searchable: true
        },
        {
          field: "additional_info",
          label: "Additional Information",
          searchable: true
        },
        {
          field: "action",
          label: "Action",
          searchable: true
        },
        {
          field: "updated_by",
          label: "Updated By",
          searchable: true
        },
        {
          field: "updated_at",
          label: "Updated At",
          searchable: true
        },
        {
          field: "actions",
          label: "",
          headerClass: "is-actions",
          cellClass: "is-actions"
        }
      ]
    };
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },
    exportHistoryReportingCategory() {
      this.reportingCategoryService.exportReportingCategoryHistory(
        this.$route.params.id
      );
      this.$emit("confirm");
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
